// Reviews.jsx
import React from "react";
import ReviewCard from "./ReviewCard";

const Reviews = () => {
  return (
    <section id="reviews" className="bg-[#f5f7fa] py-16">
      <h2 className="text-3xl font-bold text-center text-red-700 mb-10">
        What Our Patients Say
      </h2>

      <div className="flex justify-center flex-wrap">
        <ReviewCard
          frontReview="I had an excellent experience with this lab. The staff is highly professional, courteous, and well-trained. The entire process—from registration to sample collection—was smooth, hygienic, and well-organized. The phlebotomist was skilled, and the blood draw was quick and painless."
          frontName="Tushar Padekar"
          backReview="Exceptional service, top-notch facilities, and a team of highly skilled professionals! The pathology lab exceeded my expectations in every way. From the moment I walked in, I was treated with care and compassion. The staff were knowledgeable, efficient, and explained everything in detail."
          backName="Aishwarya Kurhade"
        />

        <ReviewCard
          frontReview="Really great experience! The staff was super friendly and made the whole process smooth and stress-free. The lab was clean and everything felt very organized. Got my reports quickly and they were easy to understand. Definitely recommend this place if you need any tests."
          frontName="Omkar Deshpande"
          backReview="Accurate reports and quick updates. I trust this lab for all my test Painless sample collection and professional approach. Highly satisfied."
          backName="Rutik Gade"
        />
      </div>
    </section>
  );
};

export default Reviews;
